import { Component } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { DeviceEssService } from '../../../Model/DeviceEss/device-ess.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-device-configuration',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, LoaderComponent, RouterModule, NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './device-configuration.component.html',
  styleUrl: './device-configuration.component.scss'
})
export class DeviceConfigurationComponent {
  isDisabled: boolean = false;
  DeviceData: any[] = [];

  deviceConfig = {
    endPoint: "",
    requestBody: {
      DeviceSerialNo: null,
      CompanyCode: null,
      FromDate: null as any,
      ToDate: null as any,
    },
    httpMethod: "Post"
  }

  filter = {
    FromDateObj: null as any,
    ToDateObj: null as any,
    DeviceToDBRequest: null as any,
    DeviceToDBExecute: null as any,
    DeviceDBToEssRequest: null as any,
    DeviceDBToEssExecute: null as any,
    LastRestartRequest: null as any,
    LastRestartExecute: null as any,
    status: 0,
  }

  Sites = [] as any;
  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private deviceess: DeviceEssService,
    private session: SessionService,
    private route: ActivatedRoute,
    private dateFormat: CustomDateParserFormatter,
    private utility: UtilityService,
    private employeeRegistration: EmployeeRegistrationService,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.deviceConfig.requestBody.DeviceSerialNo = params['sn']);
    this.deviceConfig.requestBody.CompanyCode = this.session.GetUserDetails().CompanyCode;
  }

  ngOnInit(): void {
    //this.GetDevices();
    this.ESS_AdditionalFillCombo();
    this.GetDeviceDetail();
    this.SelectDate('RegistrationDate', null, null);
  }

  GetDevices() {
    this.isDisabled = true;
    this.DeviceData = [];
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/devicestatus", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, BSCode: this.Sites.map((e: any) => e.SiteMasterID).toString() }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response && response.length > 0) {
            this.DeviceData = response;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDeviceDetail() {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/devicestatus", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.deviceConfig.requestBody.DeviceSerialNo }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response && response.length > 0) {
            this.filter.DeviceToDBRequest = response[0].DeviceToDBRequest;
            this.filter.DeviceToDBExecute = response[0].DeviceToDBExecute;
            this.filter.DeviceDBToEssRequest = response[0].DeviceDBToEssRequest;
            this.filter.DeviceDBToEssExecute = response[0].DeviceDBToEssExecute;
            this.filter.LastRestartRequest = response[0].LastRestartRequest;
            this.filter.LastRestartExecute = response[0].LastRestartExecute;
            this.filter.status = response[0].status;
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Restart() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to restart device?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.deviceConfig.endPoint = 'DeviceESS/restart';
        this.deviceess.commonDeviceApi(this.deviceConfig).subscribe({
          next: (response) => {
            try {
              if (response && response.success) {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              }
            } catch (e) { }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  SetDateTime() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to set current datetime?';
    modalRef.componentInstance.Message2 = 'The server date and time will be applied when the command is executed.';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.deviceConfig.endPoint = 'DeviceESS/datetime';
        this.deviceess.commonDeviceApi(this.deviceConfig).subscribe({
          next: (response) => {
            try {
              if (response && response.success) {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              }
            } catch (e) { }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  DeviceToDeviceDB() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to sync data device to device db';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.deviceConfig.endPoint = 'DeviceESS/devicetodevicedb';
        this.deviceess.commonDeviceApi(this.deviceConfig).subscribe({
          next: (response) => {
            try {
              if (response && response.success) {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              }
            } catch (e) { }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  DeviceDBToEss() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to sync data device db to ess';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.deviceConfig.endPoint = 'DeviceESS/devicedbtoess';
        this.deviceConfig.requestBody.FromDate = this.dateFormat.format(this.filter.FromDateObj);
        this.deviceConfig.requestBody.ToDate = this.dateFormat.format(this.filter.ToDateObj);
        this.deviceess.commonDeviceApi(this.deviceConfig).subscribe({
          next: (response) => {
            try {
              if (response && response.success) {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.message;
                modalRef.result.then((result: any) => { });
              }
            } catch (e) { }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.Sites = [];

    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'SW', UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.Sites = [...new Map(response.Table1.map((e: any) => ({ SiteMasterID: e.SiteCode, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];

          this.GetDevices()
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
